import { render, staticRenderFns } from "./LogisticsModal.vue?vue&type=template&id=497da7c2"
import script from "./LogisticsModal.vue?vue&type=script&lang=ts"
export * from "./LogisticsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports